// extracted by mini-css-extract-plugin
export default {"spinnerBlock":"tXT2QNnPly"};